import React from "react";
import { Table, TableRow } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { ElementTag } from "./ElementTag";
import { TableContext } from "./useTable";
import { TableRowContext } from "./useTableRow";
import { TableCellEditor } from "./TableCellEditor";

export function TableRowEditor(props: {
	row: TableRow,
}) {
	const designer = useDesigner();

	const tableState = React.useMemo(() => {
		return {
			row: props.row,
		};
	}, [props.row]);

	const cells = [];
	let i = 0;
	for(let c of props.row.cells) {
		if (!c.id) c.id = designer.nextID();
		if (c.type !== "tableCell") c.type = "tableCell";

		cells.push(
			<TableCellEditor cell={c} index={i} key={c.id} />
		);
		i++;
	}

	const elementContext = useElementContext(props.row);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const style = designer.createStyle(props.row);

	return (
		<ElementContext.Provider value={elementContext}>
			<TableRowContext.Provider value={tableState}>
				<tr
					className={
						"table-row-editor content-element " + state.classes
						+ (props.row.list ? "group" : "")
					}
					data-key={props.row.id}
					id={state.elementID}

					style={style}
					key={state.token}
				>
					{cells}
				</tr>
			</TableRowContext.Provider>
		</ElementContext.Provider>
	);
}
